import { getAuthorization } from 'controllers/controller';
import { getJobStatsByIdService } from 'services';

export const getJobTalentStats = async (jobId) => {
  const authorization = getAuthorization();

  const { data } = await getJobStatsByIdService(authorization, jobId);

  return data.response.statusCounts;
};

export const formatJobTalentStats = (response) => {
  const STATUS_ARRAY = [
    'Applied',
    'Shortlisted',
    'Interview',
    'Offered',
    'Hired',
    'Rejected',
  ];

  const STATUS_MAP = {
    Sourced: [
      'Applied',
      'Shortlisted',
      'Interview',
      'Offered',
      'Hired',
      'Rejected',
    ],
    Shortlisted: ['Shortlisted'],
    Interviewed: ['Interview'],
    Hired: ['Hired'],
  };

  const filteredStats = response.filter((status) =>
    STATUS_ARRAY.includes(status.talentStatus)
  );

  const labels = Object.keys(STATUS_MAP)
    .map((key) => {
      const count = STATUS_MAP[key].reduce((acc, value) => {
        const matchingStat = filteredStats.find(
          (stat) => stat.talentStatus === value
        );

        return acc + (matchingStat ? matchingStat.count : 0);
      }, 0);

      return {
        count,
        value: key,
      };
    })
    .sort((a, b) => b.count - a.count);

  const countMap = labels.reduce(
    (acc, { count, value }) => ({
      ...acc,
      [value]: count,
    }),
    { Sourced: 0, Shortlisted: 0, Interviewed: 0, Hired: 0 }
  );

  const appliedCount = countMap['Sourced'];
  const shortlistedCount =
    (countMap['Shortlisted'] * 25) / appliedCount || 0.05;
  const interviewedCount =
    (countMap['Interviewed'] * 25) / appliedCount || 0.05;
  const hiredCount = (countMap['Hired'] * 25) / appliedCount || 0.05;

  const data = [
    {
      data: [
        [0, 0],
        [0, 50],
        [5, 25 + interviewedCount],
        [10, 25 + interviewedCount],
        [10, 25 - interviewedCount],
        [5, 25 - interviewedCount],
      ],
    },
    {
      data: [
        [10, 25 - interviewedCount],
        [10, 25 + interviewedCount],

        [15, 25 + shortlistedCount],
        [20, 25 + shortlistedCount],
        [20, 25 - shortlistedCount],
        [15, 25 - shortlistedCount],
      ],
    },
    {
      data: [
        [20, 25 - shortlistedCount],
        [20, 25 + shortlistedCount],
        [25, 25 + hiredCount],
        [30, 25 + hiredCount],
        [30, 25 - hiredCount],
        [25, 25 - hiredCount],
      ],
    },
    {
      data: [
        [30, 25 - hiredCount],
        [30, 25 + hiredCount],
        [40, 25 + hiredCount],
        [40, 25 - hiredCount],
      ],
    },
  ];

  return { labels, data };
};
